"use strict";

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaleorAPI = void 0;

var data_1 = require("../data");

var ApolloClientManager_1 = require("../data/ApolloClientManager");

var LocalStorageHandler_1 = require("../helpers/LocalStorageHandler");

var jobs_1 = require("../jobs");

var state_1 = require("../state");

var Auth_1 = require("./Auth");

var Cart_1 = require("./Cart");

var Checkout_1 = require("./Checkout");

var collections_1 = require("./collections/collections");

var categories_1 = require("./categories/categories");

var products_1 = require("./products/products");

__exportStar(require("./Checkout"), exports);

__exportStar(require("./Cart"), exports);

var SaleorAPI = /*#__PURE__*/_createClass(function SaleorAPI(client, apiProxy, config, onStateUpdate) {
  _classCallCheck(this, SaleorAPI);

  this.legacyAPIProxy = apiProxy;
  var localStorageHandler = new LocalStorageHandler_1.LocalStorageHandler();
  var apolloClientManager = new ApolloClientManager_1.ApolloClientManager(client);
  var jobsManager = new jobs_1.JobsManager(localStorageHandler, apolloClientManager);
  var saleorState = new state_1.SaleorState(config, localStorageHandler, apolloClientManager, jobsManager);
  var localStorageManager = new data_1.LocalStorageManager(localStorageHandler, saleorState);

  if (onStateUpdate) {
    saleorState.subscribeToNotifiedChanges(onStateUpdate);
  }

  this.auth = new Auth_1.AuthAPI(saleorState, jobsManager, config);
  this.checkout = new Checkout_1.SaleorCheckoutAPI(saleorState, jobsManager, config);
  this.cart = new Cart_1.SaleorCartAPI(localStorageManager, apolloClientManager, saleorState, jobsManager, config);
  this.categories = new categories_1.CategoriesAPI(client);
  this.collections = new collections_1.CollectionsAPI(client, config);
  this.products = new products_1.ProductsAPI(client, config);
  this.legacyAPIProxy.attachAuthListener(function (authenticated) {
    if (!authenticated) {
      localStorageHandler.setCheckout({});
      localStorageHandler.setPayment({});
      localStorageHandler.setJobs(null);
    }
  });
});

exports.SaleorAPI = SaleorAPI;